/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Team_Manager_Create_Team_FailedInputs */

const en_team_manager_create_team_failed = /** @type {(inputs: Team_Manager_Create_Team_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error creating new team. ${i?.error}`)
};

const fr_team_manager_create_team_failed = /** @type {(inputs: Team_Manager_Create_Team_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur lors de la création de la nouvelle équipe. ${i?.error}`)
};

const de_team_manager_create_team_failed = /** @type {(inputs: Team_Manager_Create_Team_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Erstellen des neuen Teams. ${i?.error}`)
};

const it_team_manager_create_team_failed = /** @type {(inputs: Team_Manager_Create_Team_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore durante la creazione del nuovo team. ${i?.error}`)
};

const ru_team_manager_create_team_failed = /** @type {(inputs: Team_Manager_Create_Team_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка при создании новой команды. ${i?.error}`)
};

const es_team_manager_create_team_failed = /** @type {(inputs: Team_Manager_Create_Team_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al crear nuevo equipo. ${i?.error}`)
};

const zh_cn2_team_manager_create_team_failed = /** @type {(inputs: Team_Manager_Create_Team_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`创建新团队时出错。${i?.error}`)
};

const ja_team_manager_create_team_failed = /** @type {(inputs: Team_Manager_Create_Team_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`新しいチームの作成中にエラーが発生しました。${i?.error}`)
};

const hi_team_manager_create_team_failed = /** @type {(inputs: Team_Manager_Create_Team_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`नई टीम बनाने में त्रुटि। ${i?.error}`)
};

const pt_pt2_team_manager_create_team_failed = /** @type {(inputs: Team_Manager_Create_Team_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao criar nova equipe. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Error creating new team. {error}" |
*
* @param {Team_Manager_Create_Team_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_create_team_failed = /** @type {((inputs: Team_Manager_Create_Team_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Create_Team_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_create_team_failed(inputs)
	if (locale === "de") return de_team_manager_create_team_failed(inputs)
	if (locale === "it") return it_team_manager_create_team_failed(inputs)
	if (locale === "ru") return ru_team_manager_create_team_failed(inputs)
	if (locale === "es") return es_team_manager_create_team_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_create_team_failed(inputs)
	if (locale === "ja") return ja_team_manager_create_team_failed(inputs)
	if (locale === "hi") return hi_team_manager_create_team_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_create_team_failed(inputs)
	return en_team_manager_create_team_failed(inputs)
});